import guidelineEnHtml from '../../html/guideline.en.html?raw';
import guidelineFrHtml from '../../html/guideline.fr.html?raw';
import guidelineZhHtml from '../../html/guideline.zh.html?raw';

const GUIDELINE_HTML_BY_LANGUAGE = {
  en: guidelineEnHtml,
  fr: guidelineFrHtml,
  zh: guidelineZhHtml,
} as const;

export const GUIDELINE_LANGUAGE_ORDER = [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Francais' },
  { code: 'zh', label: '中文' },
] as const;

type GuidelineHtmlVariables = {
  supplierName: string;
};

function normalizeLanguage(language: string) {
  return language.toLowerCase().split('-')[0];
}

function interpolateGuidelineHtml(
  html: string,
  variables: GuidelineHtmlVariables,
) {
  return html.replaceAll('{{ supplierName }}', variables.supplierName);
}

export function getProductionDeclarationGuidelineHtml(
  language: string,
  variables: GuidelineHtmlVariables,
) {
  const normalizedLanguage = normalizeLanguage(language);
  const html =
    normalizedLanguage in GUIDELINE_HTML_BY_LANGUAGE
      ? GUIDELINE_HTML_BY_LANGUAGE[
          normalizedLanguage as keyof typeof GUIDELINE_HTML_BY_LANGUAGE
        ]
      : GUIDELINE_HTML_BY_LANGUAGE.en;

  return interpolateGuidelineHtml(html, variables);
}

export function getProductionDeclarationGuidelineHtmlSections(
  variables: GuidelineHtmlVariables,
) {
  return GUIDELINE_LANGUAGE_ORDER.map(({ code, label }) => ({
    code,
    label,
    html: getProductionDeclarationGuidelineHtml(code, variables),
  }));
}
